export default __webpack_public_path__ + "static/media/icon.2539dab4.svg";